import instance from '@src/api/axiosInstance';
import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';

export interface ScheduleListItem {
  schedule_id: number;
  saved_analysis_id: number;
  query: string;
  visibility: string;
  frequency: 'hourly' | 'daily' | 'weekly';
  run_time: string | null;
  week_day: string | null;
  created_by: number;
  updated_by: number;
  subscribers: string[];
  created_by_username: string;
  updated_by_username: string;
  is_enabled: boolean;
  is_internal?: boolean;
}

const useGetScheduleList = ({ open }: { open: boolean }) => {
  const {
    data = [],
    isFetching,
    isError,
  } = useQuery(
    ['nexa-schedule-list'],
    async () => {
      const response = await instance.get('/nexa/schedule/list');
      return get(response, ['data', 'schedules'], []);
    },
    {
      enabled: open,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 10 * 1000,
      notifyOnChangeProps: ['isFetching', 'isError', 'data'],
    },
  );

  return { data: data as ScheduleListItem[], isFetching, isError };
};

export default useGetScheduleList;
